module.exports = __webpack_public_path__ + "catalog/items/firesafety/Location-Red/Location-Red.svg";